import { epContactInfo } from "./ep-contact-info";

export const whatsAppRedirect = () => {
    const phoneNumber = epContactInfo.whatsapp;
    const message = `Olá, professora Iasmyn!\n\nConheci o Escrita Prática e gostaria de saber mais sobre as aulas, mentorias e correções de redação. \nGostaria de receber informações sobre as modalidades disponíveis e como funciona a contratação.`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
};

export function formatCurrency(value) {
    value = value.replace(",", ".")
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(value);
}

export const handleWhatappMessage = (product) => {
  const phoneNumber = epContactInfo.whatsapp;
  const message = `Olá, professora Iasmyn!\n\nConheci o Escrita Prática pelo site e gostaria de contratar: ${product.name} ${product.description ? `📝 ${product.description}` : ""} Valor: ${formatCurrency(product.price)}.
                  \nGostaria de saber como posso realizar o pagamento. 😊`;
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, "_blank", "noopener,noreferrer");
};